module.exports = __webpack_public_path__ + "files/84820c5e630871185345003ae8cdfddb.png";